<template>
    <div class="d-flex justify-content-between">

        <h1 class="page-title">
            {{ title }}
        </h1>

        <div class="list-options d-flex align-items-center justify-content-between">

            <result-layout-selection @change-layout-mode="onChangeLayout"/>
            <result-sort-selection @change-sort-mode="onChangeSort"/>


        </div>
    </div>
    <hr/>
    <div class="list-options d-flex d-xl-none align-items-center justify-content-between">
        <button class="filters-toggle filters-toggle-btn filter-toggle-mobile d-flex d-xl-none me-3"
                @click.prevent=" store.commit( 'toggleFiltersVisibility' ) "
        ><i class="fa-light fa-sliders" aria-hidden="true"></i><span class="filter-toggle-label ms-2">Filtres</span>
        </button>

    </div>
    <hr class="d-xl-none"/>
    <div class="results-info d-flex align-items-center flex-wrap">
        <div class="num-results me-3" aria-live="polite" role="status" tabindex="0">

            <span class="value" v-if="!loading">{{ iCountResults }}</span>
            <span class="unit" v-if="!loading">&nbsp;{{ resultsCountTitle }}</span>
            <span class="value" v-if="loading">Recherche en cours...</span>

        </div>

        <div class="keywords-list d-flex align-items-center flex-wrap">
            <div class="keyword-link gray me-2 type_tag" v-for="tag in tags" :key="tag.id"> {{ tag.title }}
                <button type="button" class="ms-2 keyword-filter-button"
                        @click="unchecked(tag)"
                        @keyup.enter="unchecked(tag)"
                        @keyup.space="unchecked(tag)"

                ><span class="sr-only">{{ 'Retirer le filtre ' + tag.title}}</span>
                    <i class="fa-light fa-xmark" aria-hidden="true"></i>
                </button>
            </div>
        </div>

        <div class="keywords-list d-flex align-items-center flex-wrap">
            <div class="keyword-link gray me-2 type_keyword" v-for="(keyword,index) in keywords" :key="index"> {{ keyword }}
                <button type="button"
                        class="ms-2 keyword-filter-button"
                        @click="clearResults()"
                        @keyup.enter="clearResults()"
                        @keyup.space="clearResults()"
                ><span class="sr-only">{{ 'Retirer le filtre ' + keyword }}</span>
                    <i class="fa-light fa-xmark" aria-hidden="true"></i>
                </button>
            </div>
        </div>

        <div class="num-results me-3" aria-live="polite" role="status" tabindex="0" v-if="showRefinedResults">

            <span class="value"> {{ copydeck?.refined_search?.fr ?? '!' }}</span>

        </div>

    </div>
</template>

<script setup>

import { computed, ref, onMounted, watch } from "vue";
import { useStore }                        from "vuex";
import ResultLayoutSelection               from "./ResultLayoutSelection";
import ResultSortSelection                 from "./ResultSortSelection";


//COMPOSABLES
import { useQuerystring } from "../composables/URL";


//INIT
let store         = useStore();
const querystring = useQuerystring();

//DEFINE
const props = defineProps( [ "resultsCount", "page", "totalPage" ] );
const emit  = defineEmits( [ "change-layout-mode", "change-sort-mode", "on-clear-results", "unchecked" ] );


//COMPUTED
let copydeck = computed( () => store.state.copydeck );
let loading  = computed( () => store.getters.loading );

let iCountResults  = computed( () => props.resultsCount );
let strSearchTerms = computed( () => store.state.searchTerms ?? "" );
let searchType     = computed( () => store.state.searchType ?? "" )
let title          = computed( () => searchTitle( strSearchTerms.value, searchType.value ) );
let contextTitle   = computed( () => strSearchTerms.value.length > 0 ? ` ${strSearchTerms.value} ` : "" );
let tags           = computed( () => store.getters.checkedAsTags )
let keywords       = computed( () => [ "mot_cle", "" ].includes( searchType.value ) && contextTitle.value !== '' ? [ contextTitle.value ] : [] )
let showRefinedResults = computed ( () => (iCountResults.value > 200) && (strSearchTerms.value.length > 0) );
let body = document.querySelector( 'body' );

let loadingTimeout;

watch( loading, ( newState, oldState ) =>
{

/*console.log(( 'LOADING CHANGED', loading, newState, oldState ))*/;    // otherwise, the previous timeout might still be in the air,
    // hiding our animation almost immediately
    // if ever we're still animating, let's clear it.. which will NOT remove the class
    // and start a new one to remove it later
    if ( loadingTimeout )
    {
        clearTimeout( loadingTimeout );
    }


    if ( !newState )
    {
        // we were asked to fake the loading of results
        body.value.classList.add( 'loading-search-results' );

        loadingTimeout = setTimeout( () => body.value.classList.remove( 'loading-search-results' ), 2000 );
    }
} );

let resultsCountTitle = computed( () =>
{
    if ( loading.value )
    {
        return "Recherche en cours";
    }

    let strTitle = iCountResults.value <= 1 ? copydeck.value.resultat_singulier?.fr : copydeck.value.resultat_pluriel?.fr;

    //  if (searchType.value === "mot_cle" )
    //  {
    //      strTitle += " pour le mot-clé ";
    //  }
    // else if (searchType.value === "descripteurs")
    // {
    //     strTitle += " pour le descripteur ";
    // }
    //  else if (strSearchTerms.value.length > 0)
    {
        // strTitle += " pour ";
    }

    let strPage = props.totalPage > 0 ? " - Page " + (props.page + 1) + " sur " + props.totalPage : "";
    return strTitle + contextTitle.value + strPage;
} )

//METHODS

function searchTitle ( strSearchTerms, strType )
{
    return strSearchTerms.length > 0 ? copydeck.value.pageTitleSearch.fr : copydeck.value.pageTitle.fr
}


function onChangeLayout ( layout )
{
    emit( "change-layout-mode", layout )
}

function onChangeSort ( sort )
{
    emit( "change-sort-mode", sort )
}


function unchecked ( tag )
{
    store.commit( "checked", { checked : false, id : tag.id } )

    //if ( store.state.checked.length === 0 )
    if ( tags.value.length === 0 && keywords.value.length === 0 )
    {
        store.commit( "clearSearch" );
        store.dispatch( "search", { searchTerm : "" } );
    }

    emit( "unchecked" )
}

function clearResults ()
{
    store.commit( "clearSearch" );
    store.dispatch( "search", { searchTerm : "" } );

    emit( 'on-clear-results' );
}


onMounted( () => tags.value )

</script>

<style scoped>

</style>
